import {createTheme} from "@material-ui/core";
import { createThemePalette, colors } from "./theme/colors";

export default function configureTheme() {
    return createTheme({
        drawerWidth: 240,
        palette: {
            ...createThemePalette(),
            error: {
                main: colors.palette.error,
                light: '#FF6B77', // 밝은 톤
                dark: '#E02D42',  // 어두운 톤
                contrastText: colors.main.text03,
            },
        },
        components: {
            // 전역 리플 효과 색상 설정
            MuiTouchRipple: {
                styleOverrides: {
                    root: {
                        color: colors.main.primary, // 프로젝트 기본 색상 사용
                    },
                },
            },
            // 버튼별로 다른 색상 적용
            MuiButton: {
                styleOverrides: {
                    root: {
                        '& .MuiTouchRipple-root': {
                            color: colors.main.primary, // 기본 버튼 리플 색상
                        },
                    },
                    // Error 버튼 전용 스타일
                    colorError: {
                        backgroundColor: colors.palette.error,
                        color: colors.main.text03,
                        '&:hover': {
                            backgroundColor: '#E02D42', // 호버 시 어두운 톤
                        },
                        '& .MuiTouchRipple-root': {
                            color: colors.main.text03, // Error 버튼의 리플 색상
                        },
                    },
                },
            },
        },
    });
};
